module.exports = __webpack_public_path__ + "static/media/shirt_size.2e5e1916.jpeg";